import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class FrontendScriptFound {
    scriptId: string;
    lineNumber: number;
    line: string;
    groups: OrdinaryObject = {};

    constructor(scriptId: string, lineNumber: number, line: string, groups?: OrdinaryObject) {
        this.scriptId = scriptId;
        this.lineNumber = lineNumber;
        this.line = line;
        this.groups = groups;
    }
}
